export interface CheckoutReq {
  permanentDomain: string; // myshopify domain, get from query param
  requestId: string; // domain input in browser, get from query param
  currency: string;
  items: CheckoutItem[];
  totalAmount: number | string; // new field
  creditUsage?: CheckoutItem;
}

export interface CheckoutItem {
  sku: string;
  name: string;
  description: string;
  externalProductId: number;
  externalVariantId: number;
  quantity: number;
  unitSalePriceExclTax: number;
  subtotalAmount: number;
  taxAmount: number;
  totalAmount: number;
  subItemLines: SubItemLine[];
  taxLines: Tax[];

  productId?: number;
  variantId?: number;
  title?: string;
  taxRate?: number;
}

export interface SubItemLine {
  productId: string;
  sku: string;
  saleModel: string;
  name: string;
  description: string;
  quantity: number;
  unitSalePriceExclTax: number;
  subtotalAmount: number;
  taxAmount: number;
  tax: Tax;
  totalAmount: number;
  numberSku?: string; // has number license
  numberProductId?: string; // has number license
}

export interface Tax {
  label: string;
  rate: number;
  amount: number;
}
export interface QuantityDetail {
  [numberSku: string]: number;
}

export class PaymentIntent {
  clientSecret: string;
  checkoutToken: string;
  currency: string;
  totalAmount: number;
  items: CheckoutItem[];
  subTotalAmount?: number;
  taxAmount?: number;
  totalAmountAfterDiscount?: number;

  constructor(obj?: Partial<PaymentIntent>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }

  get shouldShowSelectNumbers() {
    return this.items?.some(item => item?.subItemLines?.find(subItemLine => subItemLine.numberSku));
  }

  get hasSGNumber() {
    return this.shouldShowSelectNumbers && this.numberSkus.some(numberSku => numberSku === 'SG');
  }

  get numberSkus() {
    if (!this.shouldShowSelectNumbers) {
      return [];
    }

    return (
      this.items
        ?.flatMap(item => item?.subItemLines)
        ?.filter(subItemLine => subItemLine.numberSku)
        ?.map(subItemLine => subItemLine.numberSku)
        ?.filter((numberSku, index, self) => self.indexOf(numberSku) === index) || []
    );
  }

  get totalQuantity() {
    return (
      this.items?.reduce((acc, item) => {
        const numberQuantity = item?.subItemLines
          ?.filter(subItem => subItem.numberSku)
          .reduce((subAcc, subItem) => subAcc + subItem.quantity, 0);

        const bundleQuantity = numberQuantity * item.quantity;

        return acc + bundleQuantity;
      }, 0) || 0
    );
  }

  get quantityDetail(): QuantityDetail {
    return this.items?.reduce((acc, item) => {
      item?.subItemLines?.forEach(subItem => {
        if (subItem.numberSku) {
          acc[subItem.numberSku] = (acc[subItem.numberSku] || 0) + subItem.quantity * item.quantity;
        }
      });
      return acc;
    }, {});
  }
}

export interface PaymentCompletedReq {
  checkoutToken: string;
  customer: Customer;
  billingAddress: BillingAddress;
  // numbers: CheckoutNumber[];
}

export interface BillingAddress {
  name: string;
  address1: string;
  address2: string;
  city: string;
  zip: string;
  country: string;
  countryCode: string;
  province?: string;
  phone?: string;
}

export interface Customer {
  email: string;
  firstName: string;
  lastName: string;
}

export interface PaymentStatus {
  checkoutStatus: 'pending' | 'completed';
  paymentStatus: 'pending' | 'completed' | 'failed';
}

export interface AddressObj {
  name: string;
  phone: string;
  address: Address;
  firstName: string;
  lastName: string;
}

export interface Address {
  line1: string;
  line2: null;
  city: string;
  country: string;
  postal_code: string;
  state: string;
}

export interface CheckoutNumberInfo {
  numberSku: string;
  numbers: CheckoutNumber[];
}

export interface CheckoutNumber {
  number: string;
  productId: string;
  sku: string;
  country?: string;
}

export interface CheckoutCompleteResp {
  orderToken: string;
}

export interface ProvisionReq {
  orderToken: string;
  numbers: CheckoutNumber[];
}
